export default "__VITE_ASSET__CiZ4$wvM__"